import { getPersonCompany, getPersonFullName, getPersonLocation } from "../utils/prospectUtils";
import type { ProspectItem } from "../types";

// Placeholder text the cells show when a value is missing; sorted as empty (last).
const orNull = (value: string, placeholder: string) => (value && value !== placeholder ? value : null);

// Fixed widths (tableLayout "fixed") keep the table inside one view: long values end in
// "…" and show in full on hover instead of wrapping or pushing columns off-screen.
// Contact and Actions hold one chip / one button, so the room goes to Company and Location.
// Click a header to sort; sortValue is what the cell shows, so the order matches the screen.
export const PROSPECT_RESULT_COLUMNS = [
  {
    name: "Name",
    uid: "name",
    align: "left" as const,
    width: "19%",
    sortable: true,
    sortValue: (p: ProspectItem) => orNull(getPersonFullName(p), "Unnamed contact"),
  },
  {
    name: "Title",
    uid: "title",
    align: "left" as const,
    width: "17%",
    sortable: true,
    sortValue: (p: ProspectItem) => p.title || p.headline || null,
  },
  {
    name: "Company",
    uid: "company",
    align: "left" as const,
    width: "17%",
    sortable: true,
    sortValue: (p: ProspectItem) => orNull(getPersonCompany(p), "Company not specified"),
  },
  {
    name: "Industry",
    uid: "industry",
    align: "left" as const,
    width: "13%",
    sortable: true,
    sortValue: (p: ProspectItem) => p.organization?.industry || p.industry || null,
  },
  {
    name: "Location",
    uid: "location",
    align: "left" as const,
    width: "15%",
    sortable: true,
    sortValue: (p: ProspectItem) => orNull(getPersonLocation(p), "Location not specified"),
  },
  {
    name: "Contact",
    uid: "contact_info",
    align: "left" as const,
    width: "14%",
    sortable: true,
    // Most reachable first when descending: verified email and phone (2), one of them (1), none (0).
    sortValue: (p: ProspectItem) => (p.email ? 1 : 0) + (p.phone ? 1 : 0),
  },
  { name: "Actions", uid: "actions", align: "center" as const, width: "5%" },
];
